import CreateNewAudit from "./CreateNewAudit";

const CreateNewAuditContainer = (props: any) => {
    const {onChangeAuditYear, yearsDropDown, onDateChange, auditDetails, maxDateRange, minDateRange, error, isEditClick, isNotEditable, disableAuditYear} = props
    return  <CreateNewAudit 
                yearsDropDown={yearsDropDown}
                onChangeAuditYear={onChangeAuditYear} 
                onDateChange={onDateChange} 
                auditDetails={auditDetails}
                maxDateRange={maxDateRange}
                minDateRange={minDateRange}
                error={error}
                isEditClick={isEditClick}
                isNotEditable= {isNotEditable}
                disableAuditYear = {disableAuditYear}
            />
}

export default CreateNewAuditContainer;